import { getBeneficiariesByProgrammeAreaOptions } from 'acr_ui/sources/components/dataPresentation/actualVsPlannedAdjustments';
import { getReduxConnectedViewModeOptions as getAnnualCBTCommodityVoucherDistributionViewModeOptions } from 'acr_ui/sources/components/dataPresentation/annualCBTCommodityVoucherDistribution';
import { getReduxConnectedViewModeOptions as getAnnualFoodDistributionViewModeOptions } from 'acr_ui/sources/components/dataPresentation/annualFoodDistribution';
import {
  BeneficiariesByAgeGroupComponent,
  getBeneficiariesByAgeGroupOptions,
} from 'acr_ui/sources/components/dataPresentation/beneficiariesByAgeGroup';
import { getBeneficiariesByModalityOptions } from 'acr_ui/sources/components/dataPresentation/beneficiariesByModality';
import { getBeneficiariesByResidenceStatusOptions } from 'acr_ui/sources/components/dataPresentation/beneficiariesByResidenceStatus';
import { CrossCuttingTable } from 'acr_ui/sources/components/dataPresentation/crosscuttingtables';
import CSPFinancialOverview from 'acr_ui/sources/components/dataPresentation/cspFinancialOverview';
import { GaMTable } from 'acr_ui/sources/components/dataPresentation/gamTable';
import { OutputsOutcomesTable } from 'acr_ui/sources/components/dataPresentation/outputsOutcomesTable';
import { R2RTable } from 'acr_ui/sources/components/dataPresentation/r2rTable';
import { TotalBeneficiariesComponent } from 'acr_ui/sources/components/dataPresentation/totalBeneficiaries';
import { getTransfersByModalityOptions } from 'acr_ui/sources/components/dataPresentation/transfersByModality';
import { StyledDataArrayTableComponent } from 'acr_ui/sources/components/tables/styledDataArrayTable';
import { getReduxConnectedViewModeComponent } from 'acr_ui/sources/components/widgets/viewMode';
import React from 'react';
import { connect } from 'react-redux';

import NestedParametrizedDataContainer from 'src/components/container/nestedParametrizedData';
import TotalFoodAndCBTWrapper from 'src/components/ReportTemplate/Workspace/TotalFoodAndCBTWrapper';
import { TableParametrizedDataPresentationComponent as RowSpanTable } from 'src/components/TableMain/rowspanTable';

const annualFoodDistributionViewModeOptions =
  getAnnualFoodDistributionViewModeOptions(connect);
const annualCBTCommodityVoucherDistributionViewModeOptions =
  getAnnualCBTCommodityVoucherDistributionViewModeOptions(connect);

const ViewMode = getReduxConnectedViewModeComponent(connect);

export const StrategicOutcomeTitle = (props: {
  data: { strategic_outcome?: string };
}) => <span>{props.data.strategic_outcome}</span>;

export const getDataSourceWidgetsParametersMap: Record<string, any> = {
  annual_food_transfer: {
    noModuleTitle: true,
    id: 'SUMMARY__annual_food_outcome',
    options: annualFoodDistributionViewModeOptions,
  },
  beneficiaries_by_programme_area: {
    noModuleTitle: true,
    id: 'SUMMARY__beneficiaries_by_programme_area',
    options: getBeneficiariesByProgrammeAreaOptions(),
  },
  beneficiaries_by_sex_and_age_group: {
    noModuleTitle: true,
    id: 'SUMMARY__beneficiaries_by_sex_and_age_group',
    options: getBeneficiariesByAgeGroupOptions(),
  },
  beneficiaries_by_residence_status: {
    noModuleTitle: true,
    id: 'SUMMARY__beneficiaries_by_residence_status',
    options: getBeneficiariesByResidenceStatusOptions(),
  },
  beneficiaries_by_modality: {
    noModuleTitle: true,
    id: 'SUMMARY__beneficiaries_by_modality',
    options: getBeneficiariesByModalityOptions(),
  },
  total_transfers_by_modality: {
    noModuleTitle: true,
    id: 'SUMMARY__total_transfers_by_modality',
    options: getTransfersByModalityOptions(),
  },
  annual_cash_based_transfer_and_commodity_voucher: {
    noModuleTitle: true,
    id: 'SUMMARY__annual_food_cbt',
    options: annualCBTCommodityVoucherDistributionViewModeOptions,
  },
  annual_food_distribution: {
    noModuleTitle: true,
    id: 'SUMMARY__annual_food_outcome',
    options: annualFoodDistributionViewModeOptions,
  },
  annual_cbt_and_commodity_voucher_distribution: {
    noModuleTitle: true,
    id: 'SUMMARY__annual_food_cbt',
    options: annualCBTCommodityVoucherDistributionViewModeOptions,
  },
  wfp_contribution_to_sdgs: {},

  output_and_outcome_results: {
    id: 'SO__strategic_outcome_table',
    containerClassName: 'so-table',
  },

  output_indicators: {
    parametersList: [
      'strategic_result',
      'output',
      'output_category',
      'activity',
    ],
    id: 'SO_output_values_table',
    presentationComponent: RowSpanTable,
    presentationComponentParameters: {
      headers: [
        { key: 'output_detailed_indicator', title: 'Detailed Indicator' },
        { key: 'unit_of_measure', title: 'Unit' },
        { key: 'target_value', title: 'Target Value' },
        { key: 'actual_value', title: 'Actual Value' },
        { key: 'percentage_achieved', title: '% Achieved' },
      ],
    },
  },
  outcome_indicators: {
    parametersList: [
      'strategic_result',
      'target_location',
      'activities',
      'modalities',
    ],
    id: 'SO_output_values_table',
    presentationComponent: RowSpanTable,
    presentationComponentParameters: {
      headers: [
        { key: 'strategic_result', title: 'Strategic Result' },
        { key: 'outcome_indicator', title: 'Outcome Indicator' },
        { key: 'target_location', title: 'Target / Location' },
        { key: 'activities', title: 'Activities' },
        { key: 'modalities', title: 'Modalities' },
        { key: 'gender', title: 'Gender' },
        { key: 'base_value', title: 'Base Value' },
        { key: 'latest_followup', title: 'Latest Follow Up' },
        { key: 'year_end_target', title: 'Year End Target' },
        { key: 'csp_end_target', title: 'CSP End Target' },
      ],
    },
  },

  progress_towards_gender_equality_indicators: {
    id: 'cross-cutting-gender',
    containerClassName: 'so-table',
  },
  protection_indicators: {
    id: 'cross-cutting-protection',
    containerClassName: 'so-table',
  },
  accountability_to_affected_population_indicators: {
    id: 'cross-cutting-population',
    containerClassName: 'so-table',
  },
  accountability_to_affected_people_indicators: {
    id: 'cross-cutting-population',
    containerClassName: 'so-table',
  },
  environmental_sustainability_indicators: {
    id: 'cross-cutting-environment',
    containerClassName: 'so-table',
  },
  nutrition_integration_indicators: {
    id: 'cross-cutting-nutrition',
    containerClassName: 'so-table',
  },

  // 2026 ACR Template — Cross-Cutting Priorities (indicators CC.1–CC.8)
  ensuring_protection_indicators: {
    id: 'cross-cutting-protection',
    containerClassName: 'so-table',
  },
  ensuring_accountability_to_affected_people_indicators: {
    id: 'cross-cutting-population',
    containerClassName: 'so-table',
  },
  'empowering_women_and_girls,_and_advancing_equality_indicators': {
    id: 'cross-cutting-gender',
    containerClassName: 'so-table',
  },
  integrating_environmental_sustainability_indicators: {
    id: 'cross-cutting-environment',
    containerClassName: 'so-table',
  },
  enabling_nutrition_and_healthy_diets_indicators: {
    id: 'cross-cutting-nutrition',
    containerClassName: 'so-table',
  },
  'embedding_humanitarian_principles_and_conflict-sensitivity_indicators': {
    id: 'cross-cutting-humanitarian',
    containerClassName: 'so-table',
  },
  promoting_localization_indicators: {
    id: 'cross-cutting-localization',
    containerClassName: 'so-table',
  },
  mainstreaming_assurance_indicators: {
    id: 'cross-cutting-assurance',
    containerClassName: 'so-table',
  },
};

export const DATA_SOURCES_WIDGETS_MAP: Record<string, any> = {
  total_beneficiaries: TotalBeneficiariesComponent,
  beneficiaries_by_residence_status: ViewMode,
  beneficiaries_by_age_group: BeneficiariesByAgeGroupComponent,
  beneficiaries_by_sex_and_age_group: ViewMode,
  beneficiaries_by_programme_area: ViewMode,
  beneficiaries_by_modality: ViewMode,
  total_food_and_cbt: TotalFoodAndCBTWrapper,
  total_transfers_by_modality: ViewMode,
  annual_food_transfer: ViewMode,
  annual_food_distribution: ViewMode,
  annual_cash_based_transfer_and_commodity_voucher: ViewMode,
  annual_cbt_and_commodity_voucher_distribution: ViewMode,
  wfp_contribution_to_sdgs: StyledDataArrayTableComponent,

  output_indicators: NestedParametrizedDataContainer,
  outcome_indicators: NestedParametrizedDataContainer,
  strategic_outcome_title: StrategicOutcomeTitle,
  output_and_outcome_results: OutputsOutcomesTable,
  annual_financial_overview_by_strategic_outcome_and_activity:
    CSPFinancialOverview,
  wfp_gender_and_age_marker: GaMTable,
  resources: R2RTable,

  progress_towards_gender_equality_indicators: CrossCuttingTable,
  protection_indicators: CrossCuttingTable,
  accountability_to_affected_population_indicators: CrossCuttingTable,
  accountability_to_affected_people_indicators: CrossCuttingTable,
  environmental_sustainability_indicators: CrossCuttingTable,
  nutrition_integration_indicators: CrossCuttingTable,

  // 2026 ACR Template — Cross-Cutting Priorities (indicators CC.1–CC.8)
  ensuring_protection_indicators: CrossCuttingTable,
  ensuring_accountability_to_affected_people_indicators: CrossCuttingTable,
  'empowering_women_and_girls,_and_advancing_equality_indicators':
    CrossCuttingTable,
  integrating_environmental_sustainability_indicators: CrossCuttingTable,
  enabling_nutrition_and_healthy_diets_indicators: CrossCuttingTable,
  'embedding_humanitarian_principles_and_conflict-sensitivity_indicators':
    CrossCuttingTable,
  promoting_localization_indicators: CrossCuttingTable,
  mainstreaming_assurance_indicators: CrossCuttingTable,
};
